"use client"

import { useState } from "react"
import { useLanguage } from "../contexts/LanguageContext"
import { Icons } from "./Icons"

export function LanguageSelector() {
  const { language, changeLanguage, availableLanguages } = useLanguage()
  const [isOpen, setIsOpen] = useState(false)

  const currentLanguage = availableLanguages.find((lang) => lang.code === language)

  return (
    <div style={{ position: "relative" }}>
      <button className="btn btn-sm flex items-center space-x-2" onClick={() => setIsOpen(!isOpen)}>
        <span>{currentLanguage?.name}</span>
        <Icons.ChevronDown className="w-3 h-3" />
      </button>

      {isOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: "4px",
            backgroundColor: "white",
            border: "1px solid #e5e7eb",
            borderRadius: "0.375rem",
            boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
            zIndex: 50,
            minWidth: "120px",
          }}
        >
          {availableLanguages.map((lang) => (
            <button
              key={lang.code}
              className={`btn w-full text-left px-3 py-2 text-sm hover:bg-gray-50 flex items-center space-x-2 ${
                language === lang.code ? "bg-blue-50 text-blue-600" : ""
              }`}
              onClick={() => {
                changeLanguage(lang.code)
                setIsOpen(false)
              }}
              style={{
                border: "none",
                backgroundColor: language === lang.code ? "#eff6ff" : "transparent",
                color: language === lang.code ? "#2563eb" : "#374151",
              }}
            >
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}

      {/* Overlay для закрытия dropdown */}
      {isOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 40,
          }}
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  )
}
